import { uniqueId } from 'lodash';

// NOTE: This exists for mocking purposes in unit tests
export function uniqueIdGenerator(): string {
  return uniqueId();
}
